var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left full-width"},[_c('span',_vm._g(_vm._b({style:(_vm.style),domProps:{"textContent":_vm._s(_vm.text || _vm.emptyText)}},'span',_vm.$listeners,false),_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }